export default __webpack_public_path__ + "static/media/facebook.f9f3316b.svg";